<template>
<div class="profile">
  <breadcrumb v-bind:path2="path2"></breadcrumb>
  <div class="wrap">
    <div class="nav">
      <div class="avatar_container">
        <div class="img">
          <!-- <img :src="temp" alt="Avatar" class="avatar"> -->
          <input type="file" id="file1" name="image" ref="uploadInput" accept="image/*" capture style="display:none" @change="fileChange" />
          <input type="image" :src="temp" alt="Avatar" class="avatar" style="outline: none" @click="uploadImg"/>
        </div>
        <!-- <p class="username_display">{{ $t('name') }}: {{this.$store.state.auth.userDetails.FirstName}} {{this.$store.state.auth.userDetails.LastName}}</p> -->
        <p class="username_display">{{ $t('userName') }}: {{this.$store.state.auth.userDetails.email}}</p>
        <p class="username_display">{{ $t('userId') }}: {{this.$store.state.auth.userDetails.username}}</p>
      </div>
      <div class="subnav_container">
        <ul class="subnav">
          <li :class="componentDisplayOnAccount==='informations' ?'bold':''" @click="handleNavToAccountFromNavbar('informations')">
            {{ $t('accountInformation') }}
          </li>
          <li :class="componentDisplayOnAccount==='orders' ?'bold':''" @click="handleNavToAccountFromNavbar('orders')">
            {{ $t('orderList') }}
          </li>
          <li :class="componentDisplayOnAccount==='inboundInventory' ?'bold':''" @click="handleNavToAccountFromNavbar('inboundInventory')">
            {{ $t('inboundInventory') }}
          </li>
          <li :class="componentDisplayOnAccount==='productList' ?'bold':''" @click="handleNavToAccountFromNavbar('productList')">
            {{ $t('productList') }}
          </li>
          <li :class="componentDisplayOnAccount==='paymentList' ?'bold':''" @click="handleNavToAccountFromNavbar('paymentList')">
            {{ $t('billManagement') }}
          </li>
          <li :class="componentDisplayOnAccount==='addresses' ?'bold':''" @click="handleNavToAccountFromNavbar('addresses')">
            {{ $t('editAddAddress') }}
          </li>
          <li @click="logout()" v-if="isMobile">
            {{ $t('logOut') }}
          </li>
        </ul>
      </div>
    </div>
    <div class="detail">
      <Order v-if="componentDisplayOnAccount==='orders'" />
      <Address v-if="componentDisplayOnAccount==='addresses'" />
      <Information v-if="componentDisplayOnAccount==='informations'" />
      <InboundInventory v-if="componentDisplayOnAccount==='inboundInventory'" />
      <ProductList v-if="componentDisplayOnAccount==='productList'" />
      <PaymentList v-if="componentDisplayOnAccount==='paymentList'" />
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import breadcrumb from "@/components/breadcrumb";
import Address from './address';
import Information from './information';
import Order from './order';
import InboundInventory from './inboundInventory';
import ProductList from './productList';
import PaymentList from './paymentList';

import temp from '../../assets/img/user.png';
import { isUserAuthenticated, flyToElement } from "../../store/modules/cart";

var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

export default {
  name: 'profile',
  components: {
    breadcrumb,
    Order,
    Address,
    Information,
    InboundInventory,
    ProductList,
    PaymentList,
  },
  data() {
    return {
      path2: this.$t('account'),
      currentTab: "order",
      temp: temp,
      isMobile: isMobile,
      productSwiper: {
        slidesPerView: 5,
        navigation: {
          nextEl: '.swiper-button-next.swp2',
          prevEl: '.swiper-button-prev.swp2',
        },
        breakpoints: {
          320: {
            slidesPerView: 2,
          },
          //when width >= 480
          480:{
            slidesPerView: 2,
          },
          767: {
            slidesPerView: 2,
          },
          //when width >= 640
          990: {
            slidesPerView: 3,
          },
          1200:{
            slidesPerView: 4,
          },
          1280: {
            slidesPerView: 5,
          }
        }
      },
      inCart: null,
    }
  },
  methods: {
    ...mapActions('cart', ['addProductToCart']),
    ...mapActions('products', ['fetchProductDetails']),
    ...mapActions('profile', ['updateUserPhoto']),
    ...mapMutations('navbar', ['handleNavToAccountFromNavbar']),
    ...mapMutations('auth', ['logout']),
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    ...mapMutations('products', ['updateActiveProduct']),
    handleAddToCartSuccess(item) {
      this.$store.dispatch('cart/addCart', item)
      .then(() => {
        this.$store.dispatch('cart/getCart');
      });
    },
    handleAddToCartFail() {
      alert('Not enough product in stock');
    },
    findRightElement(item, p) {
      if (item.Product_id === p) {
        return 
      }
    },
    addToCart: function(item, event) {
      if (isUserAuthenticated()) {
        this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
        .then(() => {
          flyToElement(event.target, $('.cart-link'));
        })
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item)
        .then(() => {
          this.$store.dispatch('cart/getCart');
          flyToElement(event.target, $('.cart-link'));
        })
      }
    },
    uploadImg() {
      this.$refs.uploadInput.click()
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      })
    },
    async fileChange() {
      const file = await this.toBase64(this.$refs.uploadInput.files[0]);
      this.updateUserPhoto({ "profile": file })
      .then(res=> {
        this.temp = res.data;
      })
      .catch(err => {
        console.log('err updating user photo', err)
      })
    }
  },
  computed: mapState({
    componentDisplayOnAccount: state => state.navbar.componentDisplayOnAccount,
    cartProductsList: state => state.cart.cartProductsList,
    token: state => state.auth.token,
    itemCount: state => state.cart.itemCount,
    necessaryCartItems: state => state.cart.necessaryCartItems,
    cartClicked: state => state.cart.cartClicked,
    itemAdded: state => state.cart.itemAdded,
    userDetails: state => state.auth.userDetails,
  }),
  mounted() {
    this.$store.dispatch('products/fetchCustomCategories');
    if(this.userDetails) {
      this.temp = this.userDetails.profile_picture
    }
  },
  watch: {
    itemCount: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/getCart');
        } else {
          this.$store.dispatch('cart/fetchCartProducts');
        }
      }
    },
    '$store.state.auth.userDetails': {
      immidiate: true,
      handler(newval) {
        this.temp = newval.profile_picture;
      }
    }  
  }
}
</script>

<style lang="less" scope>
@import "../../assets/css/profile.less";
@import "../../assets/css/home.less";
</style>



// WEBPACK FOOTER //
// src/view/Profile/index.vue